export const ADDON_SERVING_METHOD_VALUES = [
  'delivery',
  'takeaway',
  'eatin',
  'tableorder',
  'deliverysetlocation',
] as const;

export type AddonServingMethod = (typeof ADDON_SERVING_METHOD_VALUES)[number];

export const DEFAULT_ADDON_SERVING_METHODS: string[] = [...ADDON_SERVING_METHOD_VALUES];

export const ADDON_SERVING_METHOD_SET = new Set<string>(ADDON_SERVING_METHOD_VALUES);
export const ADDON_SERVING_METHOD_UI_CHOICES: readonly { value: AddonServingMethod; langKey: string }[] = [
  { value: 'eatin', langKey: 'STAMP_CARD_DM_EAT_IN' },
  { value: 'takeaway', langKey: 'STAMP_CARD_DM_TAKEAWAY' },
  { value: 'deliverysetlocation', langKey: 'STAMP_CARD_DM_DELIVER_TO_WORKPLACE' },
  { value: 'delivery', langKey: 'STAMP_CARD_DM_DELIVERY' },
  { value: 'tableorder', langKey: 'STAMP_CARD_DM_TABLE_SERVING' },
];

export const STAMP_CARD_DELIVERY_METHOD_KEYS = [
  'eatIn',
  'takeaway',
  'deliverToWorkplace',
  'delivery',
  'tableServing',
] as const;

export type StampCardDeliveryMethodKey = (typeof STAMP_CARD_DELIVERY_METHOD_KEYS)[number];

export const STAMP_CARD_DELIVERY_LANG_KEYS: Record<StampCardDeliveryMethodKey, string> = {
  eatIn: 'STAMP_CARD_DM_EAT_IN',
  takeaway: 'STAMP_CARD_DM_TAKEAWAY',
  deliverToWorkplace: 'STAMP_CARD_DM_DELIVER_TO_WORKPLACE',
  delivery: 'STAMP_CARD_DM_DELIVERY',
  tableServing: 'STAMP_CARD_DM_TABLE_SERVING',
};

export const STAMP_CARD_KEY_TO_ADDON_SERVING_KEY: Record<StampCardDeliveryMethodKey, AddonServingMethod> = {
  eatIn: 'eatin',
  takeaway: 'takeaway',
  deliverToWorkplace: 'deliverysetlocation',
  delivery: 'delivery',
  tableServing: 'tableorder',
};

export function stampCardDeliveryLabelLangKey(key: string): string {
  return (STAMP_CARD_DELIVERY_LANG_KEYS as Record<string, string>)[key] ?? key;
}
